module.exports = __webpack_public_path__ + "img/155.b81b50ff.png";